import capitalizeFirstLetter from '@/helpers/capitalizeFirstLetter';

const state = {
  doctor: null,
};

const getters = {
  doctor: (state) => capitalizeFirstLetter(state.doctor),
};

const mutations = {
  setDoctor(state, doctor) {
    state.doctor = doctor;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
